<template>
	<div v-if="isModalCancelOpen" class="modal">
		<button class="modal-backdrop" @click="$emit('close')"></button>
		<div class="pop-up black">
			<div class="modal-title">
				{{ $t("notification_component.modal_cancel.title") }}
			</div>
			<div class="modal-text">
				{{ $t("notification_component.modal_cancel.text") }}
			</div>
			<div class="confirm-button">
				{{ $t("notification_component.modal_cancel.confirm") }}
			</div>
			<div class="cancel-button" @click="$emit('close')">
				{{ $t("notification_component.modal_cancel.cancel") }}
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { defineProps } from "vue";

defineProps({
	isModalCancelOpen: Boolean,
});
</script>

<style lang="scss" scoped>
.modal {
	width: 100vw;
	height: 100vh;
	z-index: 99999999999;
	padding: 1rem;
	display: flex;
	align-items: center;
	justify-content: center;
	.modal-backdrop {
		position: fixed;
		width: 100%;
		background-color: var(--modal-scrim);
		height: 100vh;
		border: none;
		outline: none;
		z-index: 1;
		left: 0;
		top: 0;
		display: block;
	}
	.modal-text {
		font-size: 14px;
		color: var(--active);
	}
	.modal-title {
		font-size: 18px;
		color: var(--active);
	}
	.pop-up {
		width: 100%;
		max-width: 400px;
		padding: 32px 32px;
		border: 1px solid var(--card-article-border);
		display: flex;
		flex-direction: column;
		gap: 12px;
		color: white;
		position: relative;
		z-index: 999;
		margin: 0 !important;
		text-align: center;
		&.black {
			background: var(--sidebar-bg);
		}
		.confirm-button {
			border: var(--sidebar-menus-active-bg) 1px solid;
			color: var(--active);
			text-align: center;
			font-size: 16px;
			font-weight: 400;
			line-height: 24px;
			height: 44px;
			padding: 0px 12px;
			margin-top: 10px;
			align-content: center;
			cursor: pointer;
			width: 100%;
		}
		.cancel-button {
			color: var(--sidebar-menus-active-bg);
			background: var(--card-article-bg);
			text-align: center;
			font-size: 16px;
			font-weight: 400;
			line-height: 24px;
			align-content: center;
			height: 44px;
			padding: 0px 12px;
			cursor: pointer;
			width: 100%;
		}
	}
}
</style>
